import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import React from 'react';
import { EEOccupationalLevel } from '../../../../../Component/Model/Enum/EmploymentEquity';
import { OccupationalLevelJustificationsTable } from '../../../Deviations/Justifications/OccupationalLevel/OccupationalLevelJustificationsTable';

interface IProps {
    occupationalLevel: EEOccupationalLevel;
    isDisabled: boolean;
    year: number;
    scorecardId: string;
    showModal: boolean;
    handleCancel: () => void;
}

export const DeviationsTableModal = (props: IProps) => {
    return (
        <Dialog open={props.showModal} onClose={props.handleCancel} maxWidth='lg' fullWidth>
            <IconButton
                aria-label="close"
                onClick={props.handleCancel}
                sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <OccupationalLevelJustificationsTable
                    occupationalLevelType={props.occupationalLevel as number}
                    isOpen={props.showModal}
                    isDisabled={props.isDisabled}
                    disableCard={true}
                />
            </DialogContent>
        </Dialog>
    );
};
